import React, { Component } from 'react';
import { withFirebase } from '../../Firebase';
import { withRouter } from 'react-router-dom';
import DefaultImage from '../../../assets/example-productivity.jpg'
import LikeComponent from '../../Card/LikeComponent'
import "./ActivatedCard.css";

class ProgressCard extends Component {
  constructor(props) {
    super(props);
    this.state = { click: false, begin: false, finish: false, pending: false, capsule: this.props.capsule, numberIdeas: "", numberPolls: "", ratingOpen: false, ratingCapsule: 0, newEndDate: this.props.capsule.endDate, user: { firstname: "", lastname: "" }, activator: "" };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.capsule !== this.state.capsule) {
      this.setState({ capsule: nextProps.capsule });
      this.updateCapsuleInfo(nextProps.capsule);
    }
  }
  componentDidMount() {
    this.updateCapsuleInfo(this.props.capsule);
  }

  updateCapsuleInfo = (capsule) => {
    this.props.firebase.db
      .collection("capsules")
      .doc(capsule.id)
      .collection("ideas")
      .get()
      .then(querysnapshot => {
        let ideas = querysnapshot.docs.map(doc => {
          let data = doc.data()
          return {
            id: doc.id,
            ...data
          }
        });
        this.setState({ numberIdeas: ideas.length })
      })

    this.props.firebase.db
      .collection("capsules")
      .doc(capsule.id)
      .collection("polls")
      .get()
      .then(querysnapshot => {
        let polls = querysnapshot.docs.map(doc => {
          let data = doc.data()
          return {
            id: doc.id,
            ...data
          }
        });
        this.setState({ numberPolls: polls.length })
      })

    this.props.firebase.db
      .collection("users")
      .doc(capsule.creator)
      .get().then((doc) => {

        this.setState({ user: doc.data() })
      })

    if (capsule.activatorId) {
      this.props.firebase.db
        .collection("users")
        .doc(capsule.activatorId)
        .get().then((doc) => {
          this.setState({ activator: doc.data() })
        })
    }
  }

  openCapsule = () => {
    const { capsule } = this.state
    this.props.history.push(`/capsule/${capsule.id}`);
  }

  render() {
    const { capsule, begin, finish, pending, numberIdeas, numberPolls, newEndDate, user, activator } = this.state;

    let currentdate = new Date().getTime()
    let startDate = capsule.startedDate;
    let endDate = capsule.endDate;
    let firstvalue = currentdate - startDate;
    let secondevalue = endDate - startDate;

    let value = ((firstvalue * 100) / (secondevalue))

    if (value > 0) {
      value = Math.round(value)
    }
    else if (endDate === undefined) {
      value = 0
    }
    else {
      value = 100;
    }

    let currentNewEndDate = newEndDate ? new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(Number(newEndDate)) : ''
    let progressEndDate = endDate ? new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(Number(capsule.endDate)) : ''
    return (
      <div>
        <div className="activated-card card cursor-pointer">
          <img className="card-img-top img-cropper" onClick={this.openCapsule} src={capsule.image_url_capsule || DefaultImage} alt="Card" onError={this.props.firebase.capsuleImgError} />
          <div className="reactive-card-header">
            <div className="reactive-card-title">{capsule.title}</div>
          </div>

          <img className="reactive-card-bottom-background" src={require('../../../assets/cards/card_white_no_shape.svg')} alt="Bottom" />
          <div className="activated-card-body">
            <p className="activated-text-blue" hidden={activator === ""}> Activée par {activator.firstname} {activator.lastname}</p>
            <p className="activated-text-blue"> Créée par {user.firstname} {user.lastname}</p>
            <p className="reactive-card-other-text">{numberPolls} {(1 === numberPolls) ? 'sondage' : 'sondages'}</p>
            <p className="reactive-card-other-text">{numberIdeas} {(numberIdeas === 1) ? 'idée' : 'idées'}</p>

            <div className="reactive-card-footer">
              {capsule.tags.slice(0, 2).map((tag, index) => <div className="reactive-card-tag" key={index}>#{tag}</div>)}
              <LikeComponent
                card={"active"}
                idcapsule={capsule.id} />
              <div className="reactive-card-like-container position-logo">
                <img alt="defis" hidden={!(pending === true)} className="reactive-card-like-icon" src={require('../../../assets/cards/icon_defis_time.svg')} />
                <img alt="fuse" hidden={!(begin === true)} className="reactive-card-like-icon" src={require('../../../assets/cards/icon_defis_fusee.svg')} />
                <img alt="realise" hidden={(!finish === true)} className="reactive-card-like-icon" src={require('../../../assets/cards/icon_defis_realises.svg')} />
              </div>
            </div>
            <div className="mt-3 progress progress-bar-size">
              <div hidden={!(value >= 80 || value < 0)} className="progress-bar bg-danger" role="progressbar" style={{ width: value.toString() + "%" }} aria-valuenow={value.toString()} aria-valuemin="0" aria-valuemax="100"></div>
              <div hidden={!(value >= 50 && value < 80)} className="progress-bar bg-warning" role="progressbar" style={{ width: value.toString() + "%" }} aria-valuenow={value.toString()} aria-valuemin="0" aria-valuemax="100"></div>
              <div hidden={!(value < 50)} className="progress-bar" role="progressbar" style={{ width: value.toString() + "%" }} aria-valuenow={value.toString()} aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            {newEndDate ? <span className="date-progress-card text-right">{currentNewEndDate}</span> : <span className="date-progress-card text-right">{progressEndDate}</span>}
          </div>
        </div>
      </div>
    )
  }
}

const ProgressCardBase = withRouter(withFirebase(ProgressCard));

export default ProgressCardBase;